// removed by extract-text-webpack-plugin
module.exports = {"Recipes":"Recipes__Recipes__aI6-z","recipe__container":"Recipes__recipe__container__1M2_2","Recipe":"Recipes__Recipe__1h4wQ","Search":"Recipes__Search__15w_k"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Recipes/Recipes.css
// module id = 113
// module chunks = 0